<template>
  <nav class="navbar navbar-expand-lg sticky-top shadow-sm navbar-custom">
    <div class="container-fluid">
      <!-- Logo -->
      <RouterLink to="/" class="navbar-brand d-flex align-items-center logo-container me-auto me-lg-0">
        <img src="../assets/images/logo-gym-removebg-preview.png" class="logo-img" />
      </RouterLink>

      <!-- Botón hamburguesa -->
      <button
        class="navbar-toggler border-0 shadow-none"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#mainNavbar"
        aria-controls="mainNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="bi bi-list text-white fs-1 toggler-icon"></i>
      </button>

      <!-- Links centrados en desktop -->
      <div class="collapse navbar-collapse justify-content-center" id="mainNavbar">
        <ul class="navbar-nav gap-4 text-center">
          <li class="nav-item" v-for="link in links" :key="link.text">
            <RouterLink :to="link.to" class="nav-link" active-class="active-link">
              <i :class="[link.icon, 'me-1']"></i>{{ link.text }}
            </RouterLink>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
const links = [
  { text: 'Inicio', to: '/', icon: 'bi bi-house-door' },
  { text: 'Pases Libres', to: '/PasesLibres', icon: 'bi bi-card-checklist' },
  { text: 'Planes', to: '/PlanesView', icon: 'bi bi-graph-up' },
  { text: 'Servicios', to: '/ServiciosView', icon: 'bi bi-tools' },
  { text: 'Rutinas', to: '/RutinasView', icon: 'bi bi-list-task' },
  { text: 'Contáctanos', to: '/ContactanosView', icon: 'bi bi-envelope' }
]
</script>

<style scoped>
/* Navbar general */
.navbar-custom {
  background-color: #1a1a1a;
  z-index: 50;
  padding: 0.5rem 1rem;
  height: 91px;
  overflow: visible;
  position: relative;
}

/* Logo */
.logo-container {
  overflow: visible;
  position: relative;
  z-index: 1010; /* siempre encima del menú */
}
.logo-img {
  width: 158px;
  height: 167px;
  position: absolute;
  top: -35px;
  left: 0;
  z-index: 1010;
  transition: transform 0.3s ease, filter 0.3s ease;
}
.logo-container:hover .logo-img {
  transform: scale(1.15) rotate(-10deg);
  filter: drop-shadow(0px 0px 10px #F97316);
}

/* Links */
.navbar-nav .nav-link {
  color: #fff;
  font-weight: 500;
  transition: transform 0.25s ease, color 0.25s ease, text-shadow 0.25s ease;
}
.navbar-nav .nav-link:hover {
  color: #F97316;
  transform: translateY(-2px) scale(1.05);
  text-shadow: 0px 0px 5px rgba(249, 115, 22, 0.7);
}
.active-link {
  color: #F97316;
  font-weight: bold;
  border-bottom: 2px solid #F97316;
}

/* Hamburguesa */
.toggler-icon {
  transition: transform 0.3s ease, color 0.3s ease;
}
.navbar-toggler:hover .toggler-icon {
  transform: rotate(90deg) scale(1.2);
  color: #F97316;
}

/* CTA botón */
.cta-btn {
  background-color: #F97316;
  color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.cta-btn:hover {
  transform: scale(1.08);
  box-shadow: 0px 0px 12px rgba(249, 115, 22, 0.6);
}

@media (max-width: 992px) {
  /* Menú desplegado móvil */
  #mainNavbar.collapse.show {
    position: absolute;
    top: 91px;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    z-index: 1000; /* menor que el logo */
    padding: 1rem 0;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  #mainNavbar.collapse.show .nav-link {
    color: #000 !important;
    padding: 0.75rem 1.5rem;
  }

  #mainNavbar.collapse.show .nav-link:hover {
    color: #F97316 !important;
  }

  .navbar-nav {
    flex-direction: column;
    gap: 0;
  }

  .navbar-nav .nav-item {
    border-bottom: 1px solid #e5e5e5;
  }

  /* Mantener logo encima del menú */
  .logo-container {
    z-index: 1010; /* encima del menú */
  }
  .logo-img {
    z-index: 1010; /* encima del menú */
  }
}


@media (max-width: 768px) {
  .navbar-nav {
    margin-top: 1rem;
  }
}
</style>
